import gql from 'graphql-tag';

export const ameldingListFragments = gql`
  fragment ameldingListFragments on Amelding {
    id
    calendarMonth
    humanStatus
    cancellation
    isResendable
    ameldingReference
    altinnSubmission {
      id
      sentAt
      sentBy {
        id
        name
      }
      receiptText
      archivedAt
      receivedFeedback
    }
    altinn3Submission {
      id
      sentAt
      sendingStatus
      pending
      receivedFeedback
      sentBy {
        id
        name
      }
    }
    ameldingPensionAmounts {
      id
      amount
    }
    ameldingReimbursements {
      id
      amount
    }
    ameldingWorkRelations {
      id
      workRelation {
        id
        employmentType
        employmentPercentage
        employee {
          id
          firstName
          lastName
        }
        occupation {
          id
          name
        }
      }
      ameldingWorkRelationLeaveAndLayoffs {
        id
        workRelationLeaveAndLayoff {
          id
          startDate
          endDate
          description
        }
      }
    }
    paychecks {
      id
      number
    }
    ameldingToReplace {
      id
      ameldingReference
    }
    replacementAmelding {
      id
      ameldingReference
    }
  }
`;

export const CHECK_ALTINN3_SUBMISSION_STATUS = gql`
  mutation checkAltinn3SubmissionStatus($id: ID!) {
    checkAltinn3SubmissionStatus(
      input: { altinn3SubmissionId: $id }
    ) {
      altinn3Submission {
        id
        sendingStatus
        pending
        feedbackReady
        parent {
          ...ameldingListFragments
        }
      }
    }
  }
  ${ameldingListFragments}
`;


export const GET_ALTINN3_SUBMISSION_FEEDBACK = gql`
  mutation getAltinn3SubmissionFeedback($id: ID!) {
    getAltinn3SubmissionFeedback(
      input: { altinn3SubmissionId: $id }
    ) {
      altinn3Submission {
        id
        pending
        receivedFeedback
        humanStatus
        parent {
          ...ameldingListFragments
        }
      }
    }
  }
  ${ameldingListFragments}
`;
